import React from 'react';
import Translation from "@Translation/components/Translation";

const SuggestionButton = () => (
    <button className="gb--route-element btn btn--orange" type="submit">
        <Translation translationKey="no_res.details"/>
    </button>
)

export default SuggestionButton;